const state = {
  historyList: [],
  resultList: [],
  keyword: ''
}

const actions = {
  search_a_getHistoryListData ({ state }) {
    return new Promise(resolve => {
      let list = JSON.parse(localStorage.getItem('search_list'))
      if (list && Array.isArray(list)) {
        state.historyList = list
      }
      resolve(state.historyList)
    })
  }
}
const mutations = {
  search_m_setHistoryListData (state, historyList) {
    state.historyList = historyList
    localStorage.setItem('search_list', JSON.stringify(historyList))
  },
  search_m_clearHistoryListData (state) {
    localStorage.removeItem('search_list')
    state.historyList = []
  },
  search_m_setResultListData (state, list) {
    state.resultList = list
  },
  search_m_setKeywordData (state, keyword) {
    state.keyword = keyword
  }
}

export default {
  state,
  actions,
  mutations
}
